import React from 'react';
import { useNavigate } from 'react-router-dom';

const RelatedPosts = ({ posts }) => {
  const navigate = useNavigate();

  if (!posts || posts.length === 0) return null;

  return (
    <section className="container mt-16" data-testid="related-posts">
      <div className="max-w-6xl mx-auto">
        <h2 className="section-title mb-8">Related Articles</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {posts.map((post) => (
            <div
              key={`related-${post.id}`}
              className="related-post-card cursor-pointer"
              onClick={() => navigate(`/blog/${post.slug}`)}
              data-testid={`related-post-${post.id}`}
            >
              <img src={post.image} alt={post.title} loading="lazy" />
              <div className="p-4">
                <h3 className="font-bold text-lg mb-2">{post.title}</h3>
                <p className="text-sm text-[var(--text-light)]">
                  {post.readTime}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RelatedPosts;
